import Header from '../../lib/AppBar';
import './dashboard.scss';
import './commercial.scss';
import en from '../../lang/en-us';
import RouteWrapper from './routes';
import { DashboardRoutes } from './routeConfig';
import { getPageHeading } from '../../lib/pageHeading';
import { useState } from 'react';
import { Button, CircularProgress, Dialog } from '@material-ui/core';
import { connect, useSelector } from 'react-redux';
import { CombinedState } from 'redux';
import { RootStateType } from '../../redux-store/reducers';
import { useEffect } from 'react';
import { getPortfolio } from '../../redux-store/actions/portfolio';
import { onLogout, updateFirstTimeSettings } from '../../redux-store/actions/login';
import { FundInfoDialog } from './home';
import { AuthState } from '../../redux-store/types/login';
import { useDeviceAuthentication } from '../../lib/Authentication';
import LoginPin from '../auth/LoginPin';
import LoginSetPin from '../auth/LoginSetPin';
import { isMobileDevice } from '../../utils/constants';
import {
    getMasterFunds,
    getPurchaseDetails,
    getMasterData,
} from '../../redux-store/actions/newPurchase';
import { getAmcList } from '../../redux-store/actions/nct';
import { IsAllow } from '../../redux-store/types/portfolio';
import KYCRegisterPopup from '../common/KYCRegisterPopup';
import { NomineePopup } from './NomineePopup';

const { dashboard } = en;

const LINK = 'link';
const PORTFOLIOS = '/portfolio';
const HOME = '/home';
const NCT = '/nct';
const INVEST = '/commercial';
const TRACK = '/track';
const UNCLAIMED = '/unclaimed-payout';
const SEBICAS = '/sebi-cas';

const selectTypeByPath = (pathname: string) => {
    if (pathname.includes(HOME)) {
        return 2; // Close button is at index 1, so Home is now at index 2
    } else if (pathname.includes(PORTFOLIOS)) {
        return 3; // Portfolio is now at index 3
    } else if (pathname.includes(INVEST)) {
        return 4; // Invest is now at index 4
    } else if (pathname.includes(NCT)) {
        return 5; // NCT is now at index 5
    } else if (pathname.includes(TRACK)) {
        return 6; // Track is now at index 6
    } else if (pathname.includes(SEBICAS)) {
        return 7; // SEBI CAS is now at index 7
    } else {
        return null;
    }
};

interface ActionTabProps {
    stateKey: string;
    route?: string;
}

const HOME_ACTION: ActionTabProps = {
    stateKey: `${LINK}2`,
    route: HOME,
};
const PORTFOLIOS_ACTION: ActionTabProps = {
    stateKey: `${LINK}3`,
    route: PORTFOLIOS,
};
const INVEST_ACTION: ActionTabProps = {
    stateKey: `${LINK}4`,
    route: INVEST,
};
const NCT_ACTION: ActionTabProps = {
    stateKey: `${LINK}5`,
    route: NCT,
};
const TRACK_ACTION: ActionTabProps = {
    stateKey: `${LINK}6`,
    route: TRACK,
};
const UNCLAIMED_LAYOUT: ActionTabProps = {
    stateKey: `${LINK}6`,
    route: UNCLAIMED,
};
const SEBICAS_ACTION: ActionTabProps = {
    stateKey: `${LINK}7`,
    route: SEBICAS,
};

function Dashboard(props: any) {
    const { path } = props.match;
    const [show, setShow] = useState<boolean>(false);
    const [activeClass, setClass] = useState<boolean>(false);
    const [fundsInfoShow, setFundsInfoShow] = useState<boolean>(props.firstTimeLoggedIn);
    const { pathname = '' } = props.location;
    const [actionTab, setTab] = useState<string>(`${LINK}${selectTypeByPath(pathname)}`);
    const pageLink = pathname.replace('/portal/', '');
    const { askAuthentication } = useDeviceAuthentication({
        onAuthenticationTimeOut: () => {
            props.updateFirstTimeSettings({ isAutheticatedByDeviceOrPin: false });
            askAuthentication();
        },
    });

    const { ftTransactionFlag } = useSelector(({ authReducer }: RootStateType) => ({
        ftTransactionFlag: authReducer?.ftTransactions,
    }));
    const [open, setOpen] = useState(false);

    const pathName = [
        '/portfolio-scheme-details',
        '/portal/profile',
        '/portal/update-security-questions',
        '/portal/unclaimed-payout',
        '/portal/sebi-cas',
        '/portal/track',
        '/portal/track-for-nct',
        '/portal/track-for-transaction',
        '/portal/unregistered-folios',
        '/portal/unregistered-folios-success',
        '/portal/faq',
    ];

    const handleActionChange =
        ({ stateKey, route }: ActionTabProps) =>
        () => {
            setTab(stateKey);
            props.history.push(`${path}${route}`);
            if (show) {
                setShow(false);
            }
            if (activeClass) {
                setClass(false);
            }
        };

    useEffect(() => {
        const { location } = props;
        const { pathname } = location;
        setTab(`${LINK}${selectTypeByPath(pathname)}`);
    }, [props.location.pathname]);

    const _isMobile = isMobileDevice();

    useEffect(() => {
        async function fetchPortfolio() {
            try {
                await props.getAmcList();
                setOpen(true);
                await props.getPortfolio();
                setOpen(false);
                if (ftTransactionFlag === IsAllow.YES) {
                    props.getMasterFunds();
                    await props.getMasterData();
                }
            } catch (err: any) {
                alert(err.message);
            }
        }
        if ((_isMobile && props.isAutheticatedByDeviceOrPin) || !_isMobile) {
            fetchPortfolio();
        }
    }, [props.isAutheticatedByDeviceOrPin]);

    const findPath = (pathname: string) => {
        // if(pathname.includes('/nct/actions')){
        //     return false;
        // }
        return pathname.includes('/nct') ||
            pathname.includes('/commercial') ||
            !!pathName.find((_ele: string) => pathname.includes(_ele))
            ? true
            : false;
    };
    const _setFundInfoShow = (value: boolean) => {
        const settings: Partial<AuthState> = { firstTimeLoggedIn: false };
        props.updateFirstTimeSettings(settings);
        setFundsInfoShow(value);
    };

    // Mobile Flow

    // Set Pin and initial settings
    if (_isMobile) {
        if (!props.initialSettingsAsked) {
            if (!props.enabledPin || (!props.enableTwoFactorAuth && !props.skipDeviceAuth)) {
                return <LoginSetPin {...props} />;
            }
        }
    }
    //Ask authentication
    if (_isMobile && !props.isAutheticatedByDeviceOrPin) {
        return <LoginPin {...props} />;
    }

    return (
        <div className="container-fluid db-layout">
            <NomineePopup />
            <header>
                <Header
                    user={props.displayName ?? ''}
                    authorized={true}
                    {...props}
                    showHamburgerMenu={() => setClass(true)}
                />
            </header>
            <div
                className={`db-content ${pageLink} ${
                    findPath(pathname) ? `mobile-db-content` : ``
                }`}
            >
                <div className={`db-content-left ${activeClass && `active`}`}>
                    <nav aria-label="Main Navigation" aria-live="polite">
                        <ul className={actionTab}>
                            <li>
                                <button
                                    className="mobile_mode mobile-toggle-close"
                                    onClick={() => setClass(false)}
                                    aria-label="Close navigation menu"
                                >
                                    <img src="/images/close.svg" alt="" aria-hidden="true" />
                                </button>
                            </li>
                            <li>
                                <a
                                    onClick={handleActionChange(HOME_ACTION)}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            handleActionChange(HOME_ACTION)();
                                        }
                                    }}
                                    className={actionTab === 'link2' ? 'active' : ''}
                                    aria-current={actionTab === 'link2' ? 'page' : undefined}
                                    aria-label="Home"
                                    tabIndex={0}
                                    role="button"
                                >
                                    <img src="/images/home-active.svg" alt="" />
                                    <span>{dashboard.dashboardLeft.link1}</span>
                                </a>
                                {actionTab === 'link2' && (
                                    <span className="sr-only" role="status" aria-live="polite">
                                        Home page selected
                                    </span>
                                )}
                            </li>
                            <li>
                                <a
                                    onClick={handleActionChange(PORTFOLIOS_ACTION)}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            handleActionChange(PORTFOLIOS_ACTION)();
                                        }
                                    }}
                                    className={actionTab === 'link3' ? 'active' : ''}
                                    aria-current={actionTab === 'link3' ? 'page' : undefined}
                                    aria-label="Portfolio"
                                    tabIndex={0}
                                    role="button"
                                >
                                    <img src="/images/portfolio-active.svg" alt="" />
                                    <span>{dashboard.dashboardLeft.link2}</span>
                                </a>
                                {actionTab === 'link3' && (
                                    <span className="sr-only" role="status" aria-live="polite">
                                        Portfolio page selected
                                    </span>
                                )}
                            </li>
                            {!!ftTransactionFlag && ftTransactionFlag === IsAllow.YES && (
                                <li style={{ position: 'relative' }}>
                                    <a
                                        onClick={handleActionChange(INVEST_ACTION)}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                e.preventDefault();
                                                handleActionChange(INVEST_ACTION)();
                                            }
                                        }}
                                        className={actionTab === 'link4' ? 'active' : ''}
                                        aria-current={actionTab === 'link4' ? 'page' : undefined}
                                        aria-label="Invest"
                                        tabIndex={0}
                                        role="button"
                                    >
                                        <img src="/images/invest.svg" alt="" />
                                        <span>{dashboard.dashboardLeft.invest}</span>
                                        <div
                                            className="new-icon"
                                            role="img"
                                            aria-label="New feature"
                                            title="New feature"
                                            style={{
                                                position: 'absolute',
                                                top: 5,
                                                right: 5,
                                            }}
                                        >
                                            <svg viewBox="0 0 140 60" width="56">
                                                <polygon
                                                    points="0,5 120,5 105,25 120,45 0,45 15,25"
                                                    fill="#A67C00"
                                                />
                                                <text
                                                    x="60"
                                                    y="30"
                                                    textAnchor="middle"
                                                    fontSize="20"
                                                    fontWeight="700"
                                                    fill="#0A0A0A"
                                                >
                                                    NEW
                                                </text>
                                            </svg>
                                        </div>
                                    </a>
                                    {actionTab === 'link4' && (
                                        <span className="sr-only" role="status" aria-live="polite">
                                            Invest page selected
                                        </span>
                                    )}
                                </li>
                            )}
                            <li>
                                <a
                                    onClick={() => {
                                        setClass(false);
                                        setShow(true);
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            setClass(false);
                                            setShow(true);
                                        }
                                    }}
                                    className={actionTab === 'link5' ? 'active' : ''}
                                    aria-current={actionTab === 'link5' ? 'page' : undefined}
                                    aria-label="NCT"
                                    tabIndex={0}
                                    role="button"
                                >
                                    <img src="/images/nct-active.svg" alt="" />
                                    <span>{dashboard.dashboardLeft.link3}</span>
                                </a>
                                {actionTab === 'link5' && (
                                    <span className="sr-only" role="status" aria-live="polite">
                                        NCT page selected
                                    </span>
                                )}
                            </li>
                            <li>
                                <a
                                    onClick={handleActionChange(TRACK_ACTION)}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            handleActionChange(TRACK_ACTION)();
                                        }
                                    }}
                                    className={actionTab === 'link6' ? 'active' : ''}
                                    aria-current={actionTab === 'link6' ? 'page' : undefined}
                                    aria-label="Track"
                                    tabIndex={0}
                                    role="button"
                                >
                                    <img src="/images/status-active.svg" alt="" />
                                    <span>{dashboard.dashboardLeft.link4}</span>
                                </a>
                                {actionTab === 'link6' && (
                                    <span className="sr-only" role="status" aria-live="polite">
                                        Track page selected
                                    </span>
                                )}
                            </li>
                            {/* <li>
                            <a
                                onClick={handleActionChange(UNCLAIMED_LAYOUT)}
                                className={actionTab === 'link5' ? 'active' : ''}
                            >
                                <img src="/images/unclaimed.svg" alt="" />
                                <span>{dashboard.dashboardLeft.link5}</span>
                            </a>
                        </li> */}
                            <li>
                                <a
                                    onClick={handleActionChange(SEBICAS_ACTION)}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            handleActionChange(SEBICAS_ACTION)();
                                        }
                                    }}
                                    className={actionTab === 'link7' ? 'active' : ''}
                                    aria-current={actionTab === 'link7' ? 'page' : undefined}
                                    aria-label="SEBI CAS"
                                    tabIndex={0}
                                    role="button"
                                >
                                    <img src="/images/sebi-cas.svg" alt="" />
                                    <span>{dashboard.dashboardLeft.link6}</span>
                                </a>
                                {actionTab === 'link7' && (
                                    <span className="sr-only" role="status" aria-live="polite">
                                        SEBI CAS page selected
                                    </span>
                                )}
                            </li>
                        </ul>
                    </nav>
                </div>
                <main
                    className={`db-content-right ${findPath(pathname) ? `full-width` : ``}`}
                    id="db-content-right"
                    tabIndex={0}
                    aria-label={getPageHeading(pathname) || 'Main content'}
                >
                    <div className="maxWidth">
                        <KYCRegisterPopup />
                        <RouteWrapper
                            matchPath={path}
                            initPath={`/home`}
                            routes={DashboardRoutes}
                        />
                    </div>
                </main>
            </div>
            <Dialog maxWidth={'sm'} open={open} aria-labelledby="enable-fingerprint-modal">
                <div className="enable-fingerprint-modal">
                    <CircularProgress />
                    <p style={{ marginTop: '12px' }}>{'Fetching portfolio...'}</p>
                </div>
            </Dialog>
            <Dialog maxWidth={'sm'} open={show} aria-labelledby="note-modals">
                <div className="note-modals">
                    <h3>{dashboard.noteModals.nctModal.heading}</h3>
                    <p>{dashboard.noteModals.nctModal.info}</p>
                    <div className="note-modals-btns">
                        <Button className="customBtn" onClick={handleActionChange(NCT_ACTION)}>
                            {dashboard.noteModals.nctModal.proceedText}
                        </Button>
                        <Button className="customBtn" onClick={() => setShow(!show)}>
                            {dashboard.noteModals.nctModal.cancelText}
                        </Button>
                    </div>
                </div>
            </Dialog>
            <FundInfoDialog setFundInfoShow={_setFundInfoShow} fundInfoShow={fundsInfoShow} />
        </div>
    );
}
export default connect(
    ({ authReducer, authentication }: CombinedState<RootStateType>) => ({
        ...authReducer,
        ...authentication,
    }),
    {
        getPortfolio,
        getAmcList,
        updateFirstTimeSettings,
        onLogout,
        getMasterFunds,
        getMasterData,
    },
)(Dashboard);
